const DarkLightMode = ({ img, toggleMode }) => (
    <img
        onClick={toggleMode}
        src={img?.src}
        className={img?.className}
        style={img?.style}
        alt="dark"
    />
);

export default DarkLightMode;
